import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-unauthorized',
    imports: [MatButtonModule, RouterLink],
    templateUrl: './unauthorized.component.html',
    styleUrl: './unauthorized.component.css'
})
export class UnauthorizedComponent {}
